import React from 'react';
import PropTypes from 'prop-types';
import withWindow from '../../windowDecorators/withWindow';
import ReadMoreReadLess from '../ReadMoreReadLess';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as PharmacyIcon } from '../../../assets/svg/pharmacy.svg';

import './index.scss';

const PharmacyReport = ({
  breakpoint,
  pharmacyReport,
  pharmacyName,
  userData,
  language
}) => {
  const { firstName, genderPassport, biologicalGender } = userData;

  const getGreetingsString = () => {
    let greetingsString = 'test-result.dear-neutral';
    if (genderPassport === 'male' || biologicalGender === 'male') {
      greetingsString = 'test-result.dear-male';
    } else if (genderPassport === 'female' || biologicalGender === 'female') {
      greetingsString = 'test-result.dear-female';
    }

    return greetingsString;
  };

  // We are not using FormattedMessage here because 'ReadMoreReadLess' is
  // expecting strings for readMore and readLess. FormattedMessage returns object.
  // We have translations in de.json and en.json files
  const readMore = language === 'de' ? 'Mehr anzeigen' : 'Read more';
  const readLess = language === 'de' ? 'Weniger anzeigen' : 'Read less';

  return (
    <div className='pharmacy-report'>
      <div className='pharmacy-report__icon-wrapper'>
        <PharmacyIcon className='pharmacy-report__icon'/>
      </div>
      <div className='pharmacy-report__title'>
        <FormattedMessage
          id='test-result.comment-from-pharmacy'
          defaultMessage='Pharmacy comment'
       />
      </div>
      <div className='pharmacy-report__text'>
        <FormattedMessage id={getGreetingsString()} defaultMessage='Dear '/>
        {firstName},
      </div>
      <ReadMoreReadLess
        readMoreClassName='pharmacy-report__read-more'
        readLessClassName='pharmacy-report__read-less'
        charLimit={breakpoint === 'small' ? 150 : 300}
        readMoreText={readMore}
        readLessText={readLess}
      >
        {pharmacyReport}
      </ReadMoreReadLess>
      {pharmacyName && (
        <div className='pharmacy-report__bottom-text'>{pharmacyName}</div>
      )}
    </div>
  );
};

PharmacyReport.propTypes = {
  breakpoint: PropTypes.string,
  language: PropTypes.string,
  pharmacyName: PropTypes.string,
  pharmacyReport: PropTypes.string,
  userData: PropTypes.object
};

export default withWindow(PharmacyReport);
